<div class="container">
  <div class="row">
    <div class="col ">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4 float-left">Lista de Usuarios</p>
          <a (click)="createUser()" class="btn btn-success float-right">
            Crear usuario</a
          >
        </div>
        <div class="card-body">
          <table
            class="table table-bordered table-hover table-responsive-sm table-sm table-md"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Completo</th>
                <th>Usuario</th>
                <th>Celular</th>
                <th>Habilitado</th>
                <th>Roles</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let item of users; let i = index">
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>{{ item.nombres + ' ' + item.apellidos }}</td>
                <td>{{ item.username }}</td>
                <td>{{ item.celular }}</td>
                <td>
                  <label
                    class="switch switch_type1"
                    role="switch"
                    *ngIf="item.enabled == true"
                  >
                    <input
                      type="checkbox"
                      class="switch__toggle"
                      (click)="enableUser(item.id)"
                      checked="false"
                    />
                    <span class="switch__label"></span>
                  </label>
                  <label
                    class="switch switch_type1"
                    role="switch"
                    *ngIf="item.enabled == false"
                  >
                    <input
                      type="checkbox"
                      class="switch__toggle"
                      (click)="enableUser(item.id)"
                    />
                    <span class="switch__label"></span>
                  </label>
                </td>
                <td>
                  <div *ngFor="let rol of item.roles">
                    <label>{{ rol.display_name }}</label>
                    <!--                <div class="form-check form-check-inline">-->
                    <!--                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">-->
                    <!--                  <label class="form-check-label" for="inlineCheckbox1">{{rol.display_name}}</label>-->
                    <!--                </div>-->
                  </div>
                </td>
                <th>
                  <button
                    type="button"
                    class="btn btn-default btn-lg"
                    (click)="editarUsuario(item.id)"
                  >
                    <i
                      class="fa fa-pencil-square-o text-info"
                      style="font-size: 25px"
                    ></i>
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
